export default __webpack_public_path__ + "static/media/Item_Adventurer's_Experience.92b5d195.png";